import { TourBagDetail } from '@/api/models';
import { HeadTypeDescription } from '@/api/models/TourBagMstrPayload';
import { headTypeMap } from '@/constants';

export const createEmptyTourBagDetail = (headType: HeadTypeDescription): TourBagDetail => ({
  // SharedModel defaults
  createDate: new Date(),
  modifyDate: new Date(),
  isActive: true,
  modifyUserGuid: '',
  modifyUserName: '',
  createUserGuid: '',
  rowGuid: '',
  tstamp: '',

  // Required fields - numeric | string | boolean
  tourBagDetailId: -1,
  tourBagMstrId: -1,
  appUserName: '',
  playerId: 0,
  playerName: '',
  headTypeId: headTypeMap[headType],
  headTypeDescription: headType,
  headModelId: undefined,
  headModelName: '',
  // headModelAlternateName: '',
  tourId: 0,
  tourName: '',
  itemNo: 0,
  editSource: '',
  hand: '',
  shaftName: '',
  shaftPinstamp: '',
  shaftCosmetic: '',
  shaftTippingDigit: '',
  shaftTippingFractionId: undefined,
  shaftTippingFractionId1: undefined,
  shaftTippingFraction: '',
  isShaftLengthFinished: false,
  shaftLengthDigitId: undefined,
  shaftLengthDigitId1: undefined,
  shaftLengthDigit: '',
  shaftLengthFraction: '',
  shaftLengthFractionId: 0,
  shaftLengthFractionId1: 0,
  settingId: 0,
  settingName: '',
  cgFlatWeightId: undefined,
  cgFlatWeightName: '',
  weightNameLookupId: undefined,
  weightNameLookupName: '',
  headWeightLocationLookupId: undefined,
  headWeightLocationLookupName: '',
  headWeightNumberLookupId: undefined,
  headWeightNumberLookupName: '',
  headWeightLocationAftLookupId: undefined,
  headWeightLocationAftLookupName: '',
  headWeightNumberAftLookupId: undefined,
  headWeightNumberAftLookupName: '',
  loftId: undefined,
  loftName: '',
  loftDigitId: undefined,
  loftDigit: '',
  loftFractionId: undefined,
  loftFraction: '',
  loftDigitId1: undefined,
  loftFractionId1: undefined,
  lieDigitId: undefined,
  lieDigit: '',
  lieFractionId: undefined,
  lieFraction: '',
  lieDigitId1: undefined,
  lieFractionId1: undefined,
  measuredLoft: undefined,
  serialMstrId: undefined,
  laserNo: '',
  ct: undefined,
  ctLocation: '',
  swingWtPrefixId: undefined,
  swingWtPrefixName: '',
  swingWtSuffixId: undefined,
  swingWtSuffixName: '',
  gripTypeId: undefined,
  gripType: '',
  gripTape: '',
  gripSizeId: undefined,
  gripSize: '',
  tape: '',
  rndRib: '',
  logo: '',
  sleeve: '',
  sleeveId: undefined,
  sleeveName: '',
  shaftFlexId: undefined,
  shaftFlexName: '',
  shaftBendName: '',
  yearId: undefined,
  yearName: '',
  lie: undefined,
  sightLine: '',
  neck: '',
  weights: '',
  metalId: undefined,
  metalName: '',
  shaftBendId: undefined,
  putterHeadType: '',
  putterLevelId: 0,
  putterLevelName: '',
  putterTypeId: 0,
  putterTypeName: '',
  putterSightlineId: undefined,
  putterSightlineName: '',
  putterFaceId: undefined,
  putterFaceName: '',
  putterNeckId: undefined,
  putterNeckName: '',
  putterGripId: undefined,
  putterGripName: '',
  putterShaftId: undefined,
  putterShaftName: '',
  putterWeightId: undefined,
  putterWeightName: '',
  paintingNotes: '',
  familyId: undefined,
  familyName: '',
  familyNote: '',
  headFinishId: undefined,
  headFinishName: '',
  headFinishNote: '',
  stamping: '',
  grindDetails: '',
  ratGlue1: '',
  ratGlue2: '',
  ratGlue3: '',
  ratGlue4: '',
  ratGlue5: '',
  ratGlue6: '',
  ratGlue7: '',
  notes: '',
  orderDetailId: 0,
  tourBagMstrRowGuid: '',
  overallWeight: 0.0,
  headWeight: 0,
  drill: 0,
  tipPlug: 0,
  leadTape: 0,
  glueWeight: 0,
});
